module.exports = __webpack_public_path__ + "img/eMoveBackground.32314745.png";